import request from "@/utils/request";

export function getMuseumActivations(museumId) {
  let params = {
    museumId: museumId,
  };
  return request({
    url: `/api/MuseumActivations/MuseumActivations/${museumId}`,
    method: `get`,
    params,
  });
}

export function getMuseumActivationId(id, params) {
  return request({
    url: `/api/MuseumActivations/MuseumActivation/${id}`,
    method: `get`,
    params,
  });
}

export function postMuseumActivation(data, params) {
  return request({
    url: `/api/MuseumActivations/CreateMuseumActivation/${params.museumId}`,
    method: `post`,
    params,
    data,
  });
}

export function putMuseumActivation(id, data, params = id) {
  return request({
    url: `/api/MuseumActivations/UpdateMuseumActivation/${id}`,
    method: `put`,
    params,
    data,
  });
}

export function deleteMuseumActivation(id, params) {
  return request({
    url: `/api/MuseumActivations/DeleteMuseumActivation/${id}`,
    method: "delete",
    params,
  });
}
